import React from 'react';

function Home() {
  return (
    <div>
      <div className="py-5">
        <p>This site has resources for students enrolled in my courses
        at North Island College, that I am unable to host directly
        on NIC's network.</p>
      </div>
    </div>
  );
}

export default Home;
